<template>
  <div style="display: inline-block;">
    <el-dropdown 
      split-button
      :title="replyTicketButtonTitle"
      :type="replyTicketButtonType"
      @click="onReplyTicket"
      @visible-change="onVisibleChange"
      @command="onDropdownItem">
      {{replyTicketButtonText}}
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="privateReply" title="私密回复仅对后台用户可见 ( 在各端老版本的工单界面, 仍可能所有人可见 )">私密回复 (提交本次)</el-dropdown-item>
        <el-dropdown-item command="publicReply" title="公开回复对淘金客可见 ( 如果此淘金客是当前工单的创建人的话 )">公开回复 (提交本次)</el-dropdown-item>
        <el-dropdown-item command="switchPrivate">切换为 默认 {{'公开回复'==replyTicketButtonText?'私密回复':'公开回复'}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="提示" :visible.sync="dialogObj.show" width="330px">
      <template v-if="dialogObj.step == 1">
        <span>是否需要修改工单状态？</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onDirectReplyTicket">直接回复</el-button>
          <el-button type="primary" @click="dialogObj.step = 2">修改状态并回复</el-button>
        </span>
      </template>
      <template v-else>
        <TicketStatusSelect v-model="dialogObj.status" @change="res => dialogObj.status = res"/>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogObj.step = 1">上一步</el-button>
          <el-button type="primary" @click="onUpdateStatusAndReplyTicket">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import CacheUtil from '@/assets/utils/CacheUtil'

export default {
  name: "ReplyTicketButton",

  data () {
    return {
      disabled : false,
      replyTicketButtonType : "",
      replyTicketButtonText : "",
      replyTicketButtonTitle : "",
      dialogObj: {
        show: false,
        step: 1,
        status: 3
      }
    }
  },
  props: {
    'askUpdateStatus': {
      'default': false
    }
  },

  mounted() {
    this.loadDefault();
  },

  methods: {
    loadDefault() {
      // 默认 私密 回复; localStorage 记住
      var replyTicketButtonType = localStorage.getItem(CacheUtil.ReplyTicketButtonType);

      if ( !!replyTicketButtonType && "privateReply" == replyTicketButtonType) {
        this.replyTicketButtonType="info";
        this.replyTicketButtonText="私密回复";
        this.replyTicketButtonTitle="私密回复,鼠标指向右侧下拉三角可切换为公开回复";
        return;
      }

      this.replyTicketButtonType="primary";
      this.replyTicketButtonText="公开回复";
      this.replyTicketButtonTitle="点我提交公开回复,鼠标指向右侧下拉三角可切换为私密回复";
    },

    enable() {
      this.disabled = false;

      this.loadDefault();
    },

    disable() {
      this.disabled = true;

      this.replyTicketButtonType="info";
      this.replyTicketButtonText="正在提交";
      this.replyTicketButtonTitle="正在提交,请稍后;如果长时间未恢复,可尝试刷新页面";
    },

    onVisibleChange() {
      setTimeout(function() {
        $(".el-dropdown-menu").css("z-index", 20090);
      }, 200);
    },

    onReplyTicket(e) {
      if ( !!this.disabled && this.disabled ) {
        console.log('#76 onReplyTicket disabled', this);
        return;
      }

      var command = 'info' == this.replyTicketButtonType ? 'privateReply' : 'publicReply';
      if (this.askUpdateStatus) {
        this.dialogObj = {
          show: true,
          step: 1,
          status: 3,
          command: command
        }
      } else {
        this.$emit('click', command, '' ); // 私密或公开回复
      }
    },

    onDirectReplyTicket() {
      this.dialogObj.show = false
      this.$emit('click', this.dialogObj.command, '' );
    },

    onUpdateStatusAndReplyTicket() {
      this.dialogObj.show = false
      this.$emit('click', this.dialogObj.command, this.dialogObj.status );
    },

    onDropdownItem(command, e) {
      if ( !!this.disabled && this.disabled ) {
        console.log('#73 onDropdownItem disabled', this);
        return;
      }

      if ("switchPrivate" == command) {
        if ( "info" == this.replyTicketButtonType ) {
          this.replyTicketButtonType="primary";
          this.replyTicketButtonText="公开回复";
          this.replyTicketButtonTitle="点我提交公开回复,鼠标指向右侧下拉三角可切换为私密回复";

          localStorage.setItem(CacheUtil.ReplyTicketButtonType, "publicReply");
        } else {
          this.replyTicketButtonType="info";
          this.replyTicketButtonText="私密回复";
          this.replyTicketButtonTitle="点我提交私密回复,鼠标指向右侧下拉三角可切换为公开回复";

          localStorage.setItem(CacheUtil.ReplyTicketButtonType, "privateReply");
        }

        return;
      }

      // 私密或公开回复
      if (this.askUpdateStatus) {
        this.dialogObj = {
          show: true,
          step: 1,
          status: 3,
          command: command
        }
      } else {
        this.$emit('click', command, '');
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/ReplyTicketButton.vue